// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { any, number, string } from "@altostra/type-validations/lib/primitives";

export const isCustomObjectsTypeNameResult = objectOf({
  hits: number,
  results: arrayOf(objectOf({ any })),
});

const isCustomObjectApiItem = objectOf({
  type_name: string,
  object_id: string,
  attributes: objectOf({}),
});

export const isPostCustomObjectsTypeNameResult = objectOf({
  data_objects: arrayOf(isCustomObjectApiItem),
});
